import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth, useActiveOrganization } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { DashboardLayout } from "./components/DashboardLayout";
import { OverviewPage } from "./pages/OverviewPage";
import { AnnouncementsPage } from "./pages/AnnouncementsPage";
import { PromotionsPage } from "./pages/PromotionsPage";
import { SponsoredPage } from "./pages/SponsoredPage";
import { SitesPage } from "./pages/SitesPage";
import { VersionsPage } from "./pages/VersionsPage";
import { AuditPage } from "./pages/AuditPage";
import { UsersPage } from "./pages/UsersPage";
import { MembershipsPage } from "./pages/MembershipsPage";
import { OrganizationsPage } from "./pages/OrganizationsPage";
import { EntitlementsPage } from "./pages/EntitlementsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { PortalBundlesPage } from "./pages/PortalBundlesPage";
import { FleetPage } from "./pages/FleetPage";
import { ObservabilityPage } from "./pages/ObservabilityPage";
import { ResellerProfilesPage } from "./pages/ResellerProfilesPage";
import { LoginPage } from "./pages/LoginPage";
import { MfaEnrollPage } from "./pages/MfaEnrollPage";
import { MfaChallengePage } from "./pages/MfaChallengePage";

function TenantScopedRoutes() {
  const { user, tenantEpoch } = useAuth();
  const active = useActiveOrganization();

  if (!user) return null;

  // Block tenant pages until an organization context exists (avoids stale forms/lists).
  if (active.hasNoOrganizations || !active.organizationId) {
    return null;
  }

  const scopeKey = `${active.organizationId}:${tenantEpoch}`;

  return (
    <Routes key={scopeKey}>
      <Route path="/" element={<OverviewPage />} />
      <Route path="/announcements" element={<AnnouncementsPage />} />
      <Route path="/promotions" element={<PromotionsPage />} />
      <Route path="/sponsored" element={<SponsoredPage />} />
      <Route path="/sites" element={<SitesPage />} />
      <Route path="/versions" element={<VersionsPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="/portal-bundles" element={<PortalBundlesPage />} />
      <Route path="/fleet" element={<FleetPage />} />
      <Route path="/observability" element={<ObservabilityPage />} />
      <Route path="/reseller-profiles" element={<ResellerProfilesPage />} />
      <Route path="/memberships" element={<MembershipsPage />} />
      <Route path="/organizations" element={<OrganizationsPage />} />
      <Route path="/entitlements" element={<EntitlementsPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/settings" element={<SettingsPage />} />
    </Routes>
  );
}

function DashboardRoutes() {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <DashboardLayout user={user} onLogout={() => void logout()}>
      <TenantScopedRoutes />
    </DashboardLayout>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="auth-page">
        <p className="auth-message">در حال بارگذاری…</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route path="/mfa/enroll" element={user ? <Navigate to="/" replace /> : <MfaEnrollPage />} />
      <Route path="/mfa/verify" element={user ? <Navigate to="/" replace /> : <MfaChallengePage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <DashboardRoutes />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
